import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { OralHealthCareAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-oral-health-care-slot',
    templateUrl: './oral-health-care-slot.component.html',
    styleUrl: './oral-health-care-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OralHealthCareSlotComponent implements SheetSlotComponentBase {

	@Input() action!: OralHealthCareAction;
	value = null;

	constructor() {
	}
}